var _line, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.226,
    height: 15,
    viewBox: "0 0 20.226 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x2: 20,
    transform: "translate(0 3.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.491)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.226 8)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 20,
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 6.5 C 1.845790028572083 6.5 0.5 5.154210090637207 0.5 3.5 C 0.5 1.845790028572083 1.845790028572083 0.5 3.5 0.5 C 5.154210090637207 0.5 6.5 1.845790028572083 6.5 3.5 C 6.5 5.154210090637207 5.154210090637207 6.5 3.5 6.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 1 C 2.121500015258789 1 1 2.121500015258789 1 3.5 C 1 4.878499984741211 2.121500015258789 6 3.5 6 C 4.878499984741211 6 6 4.878499984741211 6 3.5 C 6 2.121500015258789 4.878499984741211 1 3.5 1 M 3.5 0 C 5.433000087738037 0 7 1.566999912261963 7 3.5 C 7 5.433000087738037 5.433000087738037 7 3.5 7 C 1.566999912261963 7 0 5.433000087738037 0 3.5 C 0 1.566999912261963 1.566999912261963 0 3.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.5410c7f15b4d22569f89f122b1b9e891.svg";
export { ForwardRef as ReactComponent };